import React, { useState } from "react";
import AdminIcon from "../../assets/icons/admin-icon.svg";
import InviteeIcon from "../../assets/icons/invitee-icon.svg";
import ProfileAvatar from "../ProfileAvatar/ProfileAvatar";
import { getDisplayInitials } from "../../utils/profileImage";

const CalendarAuthorImage = ({
  profileImage,
  staffName = "",
  email = "",
  showAdminIcon = true,
  imageClassName = "eve_img",
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const initials = getDisplayInitials(staffName, email);
  const hasImage = Boolean(profileImage) && !imageFailed;

  return (
    <div className="author_img">
      {showAdminIcon && <img src={AdminIcon} alt="" className="icon" />}
      {hasImage ? (
        <ProfileAvatar
          src={profileImage}
          alt=""
          className={imageClassName}
          onError={() => setImageFailed(true)}
        />
      ) : initials ? (
        <span className="author_img__initials" aria-hidden="true">
          {initials}
        </span>
      ) : (
        <span
          className="author_img__initials author_img__initials--default"
          aria-hidden="true"
        >
          <img src={InviteeIcon} alt="" className="author_img__default-icon" />
        </span>
      )}
    </div>
  );
};

export default CalendarAuthorImage;
